import React from 'react';

const AirBalloonIcon = () => {
  return <div className="air-balloon-square"></div>;
};

export default AirBalloonIcon;
